export default {
    title: 'ศึกพิมพ์ดีด',
    common: {
        time: '{minutes} นาที {seconds} วินาที',
        kpmUnit: '{count} คีย์',
        noKill: 'ยังไม่เคยกำจัดศัตรู',
        notEnoughStar: {
            title: 'ดาวชมเชยไม่พอ',
            message: 'ต้องใช้ดาวชมเชย 1 ดวงเพื่อเริ่มศึกพิมพ์ดีด',
            confirm: 'ยืนยัน',
        },
    },
    index: {
        back: 'ย้อนกลับ',
        classroomTitle: '{school} ชั้นปีที่ {grade} {class_name}',
        header: {
            name: 'ชื่อ',
            phase: 'เฟส/บอส',
            accuracy: 'ความแม่นยำ',
            time: 'เวลาที่ใช้',
            kpm: 'จำนวนคีย์',
            date: 'วันที่บันทึก',
        },
        meMark: 'ฉัน',
        recentRecord: 'บันทึกล่าสุด',
        myRanking: 'ดูอันดับของฉัน',
        empty: 'ยังไม่มีบันทึก',
        startRaid: 'เริ่มเรด',
        startFailed: 'ไม่สามารถเริ่มเรดได้',
    },
    inplay: {
        phase: 'เฟส {phase}',
        exit: 'ออก',
        combo: 'คอมโบ',
        transition: {
            phase: 'เฟส',
            completed: 'กำจัดสำเร็จ!',
            awakening: ' วินาทีต่อจากนี้ เฟส {phase} จะมาถึง',
            loading: 'กำลังโหลด...',
            skip: 'ข้าม',
        },
        nextLabel: 'ถัดไป: {next}',
        inputLabel: 'พิมพ์',
        leaveModal: {
            title: 'จะออกตอนนี้ไหม?',
            message: 'หากออกตอนนี้ ศึกพิมพ์ดีดจะสิ้นสุดด้วยบันทึกเท่าที่มีตอนนี้<br />จะออกเลยไหม?',
            no: 'ไม่',
            yes: 'ใช่',
        },
        contentError: {
            title: 'โหลดเนื้อหาไม่สำเร็จ',
            message: 'กรุณาลองอีกครั้งในภายหลัง',
            confirm: 'ยืนยัน',
        },
    },
    result: {
        gameOver: 'เกมโอเวอร์',
        bestRecord: 'ทำลายสถิติสูงสุดแล้ว! กลับไปที่ล็อบบี้แล้วดูอันดับกันเลย',
        reachedPhase: 'เฟสที่ไปถึง',
        defeatedBoss: 'มอนสเตอร์ที่กำจัด',
        defeatedUnit: 'ตัว',
        lastBoss: 'บอสสุดท้าย',
        targetKpmTooltip: 'จำนวนคีย์เป้าหมายของชั้นปีที่ {grade}: {targetKpm} คีย์',
        ranking: 'กลับไปที่ล็อบบี้',
        retry: 'เริ่มใหม่',
        registered: {
            title: 'ลงทะเบียนในอันดับของห้องแล้ว!',
            message: 'ยิ่งเฟสสูงยิ่งอันดับดี และหากเฟสเท่ากัน ยิ่งความแม่นยำ·จำนวนคีย์สูงยิ่งอันดับดี',
        },
        stats: {
            maxCombo: 'คอมโบสูงสุด',
            accuracy: 'ความแม่นยำ',
            typo: 'พิมพ์ผิด',
            time: 'เวลาที่ใช้',
            kpm: 'จำนวนคีย์',
            comboUnit: '{count} คอมโบ',
            accuracyUnit: '{count}%',
            typoUnit: '{count} ครั้ง',
            kpmUnit: '{count} คีย์',
        },
    },
};
